import { render } from "./MyCart.vue?vue&type=template&id=2685289a&scoped=true"
import script from "./MyCart.vue?vue&type=script&lang=js"
export * from "./MyCart.vue?vue&type=script&lang=js"

import "./MyCart.vue?vue&type=style&index=0&id=2685289a&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2685289a"]])

export default __exports__